import React, { useEffect, useState } from 'react';
import { Checkbox as SemanticCheckbox, Form, SemanticCOLORS, CheckboxProps, Label } from 'semantic-ui-react';

interface ParamsInterface {
    fieldClasses?: string,
    label?: string,
    colorLabel?: SemanticCOLORS,
    meta: {
        touched?: boolean,
        invalid?: boolean,
        error?: string
    },
    input: {
        value?: string,
        onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
    },
    placeholder?: string,
    title?: string,
    disabled?: boolean,
    toggle?: boolean
};

const CustomCheckBox = (params: ParamsInterface) => {

    const [checked, setChecked] = useState(params.input.value);

    useEffect(() => {
        setChecked(params.input.value);
    }, [params.input.value]);

    const onChange = (event: React.FormEvent<HTMLInputElement>, data: CheckboxProps) => {

        const changeEvent = event as React.ChangeEvent<HTMLInputElement>;

        changeEvent.target.value = data.checked ? 'true' : 'false';

        setChecked(changeEvent.target.value);

        !!params.input.onChange && params.input.onChange(changeEvent);

    }

    return <Form.Field className={ params.fieldClasses }>
        <div className='inline field' style={{ display: "flex", alignItems: "center"}} title={params.title}>
            <label className='primary-font regular'>{ params.label }</label>
            <SemanticCheckbox
                disabled={ params.disabled || false }
                placeholder={ params.placeholder }
                onChange={ onChange }
                toggle={ params.toggle || false }
                checked={ checked === 'true'}
            />
            { params.meta.touched && params.meta.invalid && <Label basic color={ params.colorLabel || 'red' } pointing>{ params.meta.error }</Label> }
        </div>
    </Form.Field>;

};

export default CustomCheckBox;